export default __webpack_public_path__ + "static/media/rewardSymbol.17a44fb3.svg";